export enum ActionPlanMeasurementType {
    trainingRecord = 'trainingRecord',
    roster = 'roster',
    invoice = 'invoice',
    sopUpdate = 'sopUpdate',
    other = 'other',
}
